import EmbedCTA from "./embedCTA";
import ColorBarCTA from "./colorBarCTA";
import TwoColCTA from "./twoColCTA";

// This is the Blog Post CTAPicker component. Keep in mind these will not be full width
// and must reference .jsx components, so we're limiting the options to EmbedCTA for now.

export default function CTAPicker({ record, embedWrapperClass }) {
  const cta = record.cta;
  if (!cta) return null;

  switch (cta.ctaType) {
    case "embed":
      return <EmbedCTA cta={cta} wrapperClass={embedWrapperClass} />;
    case "colorblock":
      return <ColorBarCTA cta={cta} />;
    case "2col":
      return <TwoColCTA cta={cta} />;
    default:
      return null;
  }
}
